var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_4af52718"]},_vm.$listeners),[_c('cube-button',{attrs:{"outline":"","primary":"","scope":"phoneNumber","tip":"需在小程序环境下预览"},on:{"getPhoneNumber":(e)=>_vm.__invoke(e, [["onGetPhoneNumber"]])}},[_vm._v("获取手机号")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }